
const $mainNote = $('[js-instructions="mainNote"]');
const $noteInput = $('[js-instructions="textarea"]');

if($mainNote){
  getClientMessages($noteInput, $mainNote)
}

// toggle textareas on checkbox click
$('[js-instructions="input"]').on('click', function(){
  const textarea = $(this).data('target');

  $(textarea).slideToggle();
  $(textarea).toggleClass('expanded-textarea');

  if(!$(textarea).hasClass('expanded-textarea')){
    $(textarea).find('textarea').val('');

    getClientMessages($noteInput, $mainNote)
  }
})

// on leaving textarea input
$noteInput.on('blur', () => {
  getClientMessages($noteInput, $mainNote)
})

function getClientMessages($textarea, $mainNote){
  let clientNoteMessage = '';

  $textarea.each(function(){
    const $this = $(this);
    const nameAttr = $this.attr('name');
    const messageValue = $this.val();
    let messageHeader = 'This is a gift: '

    if(nameAttr === 'special-instructions-textarea'){
      messageHeader = 'Special instructions: '
    }

    let message = messageValue.length > 0 ?  messageHeader + messageValue + '\n\n' : '';

    clientNoteMessage += message;
  })

  $mainNote.val(clientNoteMessage);
}

